<template>
    <div class="tab-panel padded">
        <agent-form @toggleIsDisabled="toggleIsDisabled" @formHaveErros="$emit('formHaveErros', $event)" @readyToSave="readyToSave" :passedForm="form" :isEditAgent="true"></agent-form>

        <div class="d-flex align-items-center justify-content-end" v-if="showButtons">
            <div>
                <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import AgentForm from './AgentForm'

    export default {
        mixins: [],
        data() {
            return {
                isDisabled: true,
                form: {},
            }
        },
        props: {
            showButtons: {
                default: true
            },
            agent: {
                default: null
            }
        },
        created() {
            if (this.agent) {
                this.form = this.agent;
            } else if (this.getClonedAgent && this.getClonedAgent.id !== undefined) {
                this.form = JSON.parse(JSON.stringify(this.getClonedAgent));
            } else if (this.getSelectedPerson) {
                // Landed directly on commissions from edit mode
                this.form = JSON.parse(JSON.stringify(this.getSelectedPerson));
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateAgent',
                'updateClonedAgent',
                'clearSelectedPerson',
                'updateOtaAgentInfo'
            ]),
            toggleIsDisabled(isDisabled) {
                this.isDisabled = isDisabled;
                this.$emit('toggleIsDisabled', isDisabled);
            },
            cancel() {
                this.clearSelectedPerson();
            },
            readyToSave(updatedForm) {
                this.form = updatedForm;
            },
            save() {
                // If is OTA we use a different save method
                if (this.form.isOTA) {
                    this.updateOtaAgentInfo(this.form);
                } else {
                    this.updateAgent({
                        agent: this.form
                    });
                }
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getClonedAgent'
            ])
        },
        components: {
            AgentForm
        }
    }
</script>



// WEBPACK FOOTER //
// AgentEdit.vue?2d80efc5